// src/pages/legal/Privacy.js
import React from 'react';

const Privacy = () => {
  return (
    <div className="container-custom py-12">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-2">Politique de confidentialité</h1>
        <p className="text-gray-500 mb-8">Dernière mise à jour : 15 Juin 2024</p>
        
        <div className="bg-white rounded-xl shadow-md p-6 space-y-6">
          <section>
            <h2 className="text-xl font-bold mb-3">Collecte des données personnelles</h2>
            <p className="text-gray-600">Nous collectons les informations que vous nous fournissez lors de la création de votre compte, de votre commande ou de votre inscription à notre newsletter : nom, prénom, adresse email, adresse postale, numéro de téléphone.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Utilisation des données</h2>
            <p className="text-gray-600">Vos données sont utilisées pour : traiter vos commandes, gérer votre compte client, vous envoyer des informations sur votre commande, améliorer nos services, et vous envoyer notre newsletter si vous y avez consenti.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Partage des données</h2>
            <p className="text-gray-600">Nous ne vendons pas vos données personnelles. Vos informations peuvent être partagées uniquement avec nos prestataires de services (livraison, paiement) dans le strict nécessaire à l'exécution de votre commande.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Sécurité des données</h2>
            <p className="text-gray-600">Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles pour protéger vos données contre tout accès non autorisé, perte ou destruction.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Vos droits</h2>
            <p className="text-gray-600">Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'opposition et de suppression de vos données. Pour exercer ces droits, contactez-nous à dpo@aquaexpress.fr.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Conservation des données</h2>
            <p className="text-gray-600">Vos données sont conservées pendant la durée de votre compte client et 5 ans après la dernière activité pour les données de commande, sauf opposition de votre part.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;